<template>
  <section class="news-section">
    <div class="news-header">
      <h2 class="news-heading">News</h2>
      <a href="#/news" class="news-more">All →</a>
    </div>
    <div class="news-list">
      <div v-for="item in displayNews" :key="item.id" class="news-item">
        <div class="news-source">{{ item.source }}</div>
        <div class="news-headline">{{ item.headline }}</div>
        <div class="news-meta">{{ item.time }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewsSection',
  data() {
    return {
      newsList: [
        { id: 1, source: 'CoinDesk', headline: 'Bitcoin holds steady above $78K as ETF inflows continue', time: '2h ago' },
        { id: 2, source: 'Cointelegraph', headline: 'Ethereum Layer-2 adoption hits new all-time high', time: '4h ago' },
        { id: 3, source: 'The Block', headline: 'BNB Chain launches new DeFi incentive program', time: '6h ago' },
      ]
    }
  },
  computed: { displayNews() { return this.newsList } }
}
</script>

<style scoped>
.news-section { padding: 0 var(--s-4) var(--s-5); background: var(--bg-page); }
.news-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: var(--s-3); }
.news-heading { color: var(--text-primary); font-size: var(--font-size-lg); font-weight: 700; }
.news-more { color: var(--text-dim); font-size: var(--font-size-sm); text-decoration: none; }
.news-list {
  display: flex; flex-direction: column; gap: 1px;
  background: rgba(255,255,255,0.03);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.news-item {
  display: flex; flex-direction: column; gap: var(--s-2);
  padding: var(--font-size-base) var(--s-4);
  border-bottom: 1px solid rgba(255,255,255,0.04);
}
.news-item:last-child { border-bottom: none; }
.news-source { color: var(--text-subtle); font-size: 11px; font-weight: 500; }
.news-headline { color: var(--text-primary); font-size: var(--font-size-base); line-height: 1.4; }
.news-meta { color: var(--text-dim); font-size: 11px; }
</style>
